// import React from 'react';
// import { Typography, Box } from '@mui/material';
// import Grid from '@mui/material/Grid';
// import { styled } from '@mui/material/styles';
// import { StyledDivider } from '../../../component/Typography/TypographyComponent';
// import ContanierHeading from '../../../component/resused-component/ContanierHeading';

// const services = [
// 	{
// 		id: 1,
// 		title: 'Wedding',
// 		description:
// 			'Make your wedding feast as special as your big day with our exquisite catering.',
// 		icon: '/assets/our-offer/wedding.svg',
// 	},
// 	{
// 		id: 2,
// 		title: 'Engagements',
// 		description: 'Make your engagement unforgettable with our exquisite catering.',
// 		icon: '/assets/our-offer/engagement.svg',
// 	},
// 	{
// 		id: 3,
// 		title: 'Family Events',
// 		description: 'Bring your family together with delicious catering for every special moment.',
// 		icon: '/assets/our-offer/family-events.svg',
// 	},
// 	{
// 		id: 4,
// 		title: 'Birthday Events',
// 		description: 'Celebrate your birthday with delicious flavors and unforgettable catering.',
// 		icon: '/assets/our-offer/birthday-events.svg',
// 	},
// 	{
// 		id: 5,
// 		title: 'House Warming',
// 		description: 'Warm your new home with delightful flavors and perfect catering.',
// 		icon: '/assets/our-offer/House Warming.svg',
// 	},
// 	{
// 		id: 6,
// 		title: 'Sathabhishekam',
// 		description: 'Honor this milestone with divine flavors and exceptional catering.',
// 		icon: '/assets/our-offer/sathabishagam.svg',
// 	},
// 	{
// 		id: 7,
// 		title: 'Corporate Catering',
// 		description: 'Elevate your corporate events with our seamless and delicious catering.',
// 		icon: '/assets/our-offer/corporate-catering.svg',
// 	},
// 	{
// 		id: 8,
// 		// title: 'Small Parties',
// 		title: 'Other Events',
// 		description: 'Make your small gatherings special with our delightful catering.',
// 		icon: '/assets/our-offer/small-parties.svg',
// 	},
// ];

// const ServiceCard = styled(Box)(({ theme }) => ({
// 	display: 'flex',
// 	flexDirection: 'column',
// 	alignItems: 'center',
// 	padding: theme.spacing(2),
// 	textAlign: 'center',
// 	background: '#fff',
// 	boxShadow: `0px 0px 19.38px 0px #00000014`,
// 	borderRadius: '6.46px',
// 	height: '100%',
// 	minHeight: '200px',
// 	maxHeight: '300px',
// 	minWidth: '150px',
// 	maxWidth: '250px',
// 	transition: '0.4s ease-in, 0.6s ease-in-out',
// 	'&:hover': {
// 		boxShadow: '0px 6px 10px rgb(247, 241, 241)',
// 		transform: 'scale(1.01)',
// 	},
// }));

// const ServiceTitle = styled(Typography)(({ theme }) => ({
// 	marginTop: theme.spacing(1),
// 	fontWeight: 600,
// 	fontSize: '16px',
// }));

// const ServiceDescription = styled(Typography)(({ theme }) => ({
// 	marginTop: theme.spacing(1),
// 	fontSize: '14px',
// 	color: '#555',
// }));

// const OurServices = () => (
// 	<Box
// 		sx={{
// 			flexGrow: 1,
// 			p: 2,
// 			pb: 5,
// 			backgroundImage:
// 				'url(/assets/ritual-with-coconut-leaves-traditional-hindu-wedding-ceremony-1.png)',
// 			backgroundSize: 'cover',
// 			backgroundPosition: 'center',
// 			position: 'relative',
// 		}}
// 	>
// 		<Typography
// 			sx={{ color: 'white' }}
// 			variant="body1"
// 			align="center"
// 			gutterBottom
// 			style={{ height: '3rem' }}
// 			fontWeight={700}
// 		>
// 			<Typography variant="overline" fontSize={'23.25px'}>
// 				-
// 			</Typography>{' '}
// 			Our Services{' '}
// 			<Typography variant="overline" fontSize={'23.25px'}>
// 				-
// 			</Typography>
// 		</Typography>
// 		<ContanierHeading name="What We Offer" />
// 		<Grid container spacing={2} justifyContent="center" alignItems="center">
// 			<Grid size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
// 				<Grid container spacing={2}>
// 					{services.map((service) => (
// 						<Grid
// 							size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
// 							key={service.id}
// 							sx={{
// 								textAlign: {
// 									xs: 'center',
// 								},
// 								display: { xs: 'flex' },
// 								justifyContent: { xs: 'center' },
// 								alignItems: { xs: 'center' },
// 							}}
// 						>
// 							<ServiceCard>
// 								<Box
// 									component="img"
// 									src={service.icon}
// 									alt={service.title}
// 									sx={{
// 										width: '83.95833587646484px',
// 										height: '83.95833587646484px',
// 									}}
// 								/>
// 								<ServiceTitle variant="subtitle1">{service.title}</ServiceTitle>
// 								<StyledDivider />
// 								<ServiceDescription variant="body2">
// 									{service.description}
// 								</ServiceDescription>
// 							</ServiceCard>
// 						</Grid>
// 					))}
// 				</Grid>
// 			</Grid>
// 		</Grid>
// 	</Box>
// );

// export default OurServices;
// ================================================================================================================
// ================================================================================================================
// ================================================================================================================
// ================================================================================================================
// ================================================================================================================
// ================================================================================================================
// ================================================================================================================
// ================================================================================================================
import React from 'react';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import { StyledDivider2 } from '../../../component/Typography/TypographyComponent';
import ContanierHeading from '../../../component/resused-component/ContanierHeading';

const services = [
	{
		id: 1,
		title: 'Wedding',
		description:
			'Make your wedding feast as special as your big day with our exquisite catering.',
		icon: '/assets/our-offer/wedding.svg',
	},
	{
		id: 2,
		title: 'Engagements',
		description: 'Make your engagement unforgettable with our exquisite catering.',
		icon: '/assets/our-offer/engagement.svg',
	},
	// {
	// 	id: 3,
	// 	title: 'Family Events',
	// 	description: 'Bring your family together with delicious catering for every special moment.',
	// 	icon: '/assets/our-offer/family-events.svg',
	// },
	{
		id: 3,
		title: 'Seemantham',
		description: 'Celebrate motherhood with soulful Seemantham catering.',
		icon: '/assets/our-offer/family-events.svg',
	},

	{
		id: 4,
		title: 'Birthday Events',
		description: 'Celebrate your birthday with delicious flavors and unforgettable catering.',
		icon: '/assets/our-offer/birthday-events.svg',
	},
	{
		id: 5,
		title: 'House Warming',
		description: 'Warm your new home with delightful flavors and perfect catering.',
		icon: '/assets/our-offer/House Warming.svg',
	},
	{
		id: 6,
		title: 'Sathabhishekam',
		description: 'Honor this milestone with divine flavors and exceptional catering.',
		icon: '/assets/our-offer/sathabishagam.svg',
	},
	{
		id: 7,
		title: 'Corporate Catering',
		description: 'Elevate your corporate events with our seamless and delicious catering.',
		icon: '/assets/our-offer/corporate-catering.svg',
	},
	{
		id: 8,
		// title: 'Small Parties',
		title: 'Other Events',
		description: 'Make your small gatherings special with our delightful catering.',
		icon: '/assets/our-offer/small-parties.svg',
	},
];

const ServiceCard = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	padding: theme.spacing(2),
	textAlign: 'center',
	background: '#fff',
	boxShadow: `0px 0px 19.38px 0px #00000014`,
	borderRadius: '6.46px',
	height: '100%',
	minHeight: '200px',
	maxHeight: '300px',
	minWidth: '150px',
	maxWidth: '250px',
	transition: '0.4s ease-in, 0.6s ease-in-out',
	'&:hover': {
		boxShadow: '0px 6px 10px rgb(247, 241, 241)',
		transform: 'scale(1.01)',
	},
}));

const ServiceTitle = styled(Typography)(({ theme }) => ({
	marginTop: theme.spacing(1),
	fontWeight: 600,
	fontSize: '16px',
}));

const ServiceDescription = styled(Typography)(({ theme }) => ({
	marginTop: theme.spacing(1),
	fontSize: '12px',
	color: '#555',
}));

const OurServices = () => (
	<Box
		sx={{
			flexGrow: 1,
			p: 2,
			pb: 5,
			backgroundImage:
				'url(/assets/ritual-with-coconut-leaves-traditional-hindu-wedding-ceremony-1.png)',
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			position: 'relative',
		}}
	>
		<Typography
			sx={{ color: 'white' }}
			variant="body1"
			align="center"
			gutterBottom
			style={{ height: '3rem' }}
			fontWeight={700}
		>
			<Typography variant="overline" fontSize={'23.25px'}>
				-
			</Typography>{' '}
			Our Services{' '}
			<Typography variant="overline" fontSize={'23.25px'}>
				-
			</Typography>
		</Typography>
		<ContanierHeading name="What We Offer" />
		<Grid container spacing={2} justifyContent="center" alignItems="center">
			<Grid size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
				<Grid container spacing={2}>
					{services.map((service) => (
						<Grid
							size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
							key={service.id}
							sx={{
								textAlign: {
									xs: 'center',
								},
								display: { xs: 'flex' },
								justifyContent: { xs: 'center' },
								alignItems: { xs: 'center' },
							}}
						>
							<Link
								to="/customized-menu"
								style={{ textDecoration: 'none', color: 'inherit' }}
							>
								<ServiceCard>
									<Box
										component="img"
										src={service.icon}
										alt={service.title}
										sx={{
											width: '83.95833587646484px',
											height: '83.95833587646484px',
										}}
									/>
									<ServiceTitle variant="subtitle1">{service.title}</ServiceTitle>
									<StyledDivider2 />
									<ServiceDescription variant="body2">
										{service.description}
									</ServiceDescription>
								</ServiceCard>
							</Link>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Grid>
	</Box>
);

export default OurServices;
